import { regionDetails } from '../data/appConstants';
import isEmpty from '../validator/isEmpty';

export const getRegionObject = () => {
  const validRegions = regionDetails.map((region) => region.regionDisplayName);
  const hostParts = window.location.hostname.split(/[-.]/);
  const regionFromURL = hostParts.find((part) => validRegions.includes(part));
  const region = regionDetails.find(
    (region) => region.regionDisplayName === regionFromURL
  );
  const regionObject = !isEmpty(region) ? region : regionDetails[0];
  return regionObject;
};

export const getRegionCode = () => {
  return getRegionObject().regionCode;
};

export const getRegionName = () => {
  return getRegionObject().name;
};

export const getLegalEntityName = () => {
  return getRegionObject().legalEntityName;
};

export const getLegalDocumentUrl = () => {
  return getRegionObject().documents;
};
